//src/views/Projets/Projets.js
import React, { useState, useEffect } from "react";
import Card from "../../components/Card/Card";
import { getProjets } from "../../lib/common";
import "./Projets.scss";

function Projets() {

  const [projets, setProjets] = useState([]);

  useEffect(() => {
    getProjets()
      .then((formData) => {
        console.log("PROJETS =", formData);
        setProjets(formData);
      })
      .catch((error) => console.error("Error fetching projets:", error));
  }, []);

  return (
    <main className="container">

      <section className="projets-page">

        <h1>Mes projets</h1>

        <div className="projets-grid">

          {projets.map(({ id, title, imageUrl }) => (
            <Card
              key={id}
              id={id}
              title={title}
              imageUrl={imageUrl}
              simple
            />
          ))}

        </div>

      </section>

    </main>
  );
}

export default Projets;